<template>
    <div class="ceshi">
        <iframe
            src="http://192.168.30.178:8084"
            width="100%"
            height="100%"
            frameborder="0"
            id="ifrm"
        ></iframe>
    </div>
</template>

<script>
export default {
    name: "Ceshi",
    data() {
        return {};
    },
    methods: {},
    created() {
        this.ajax.get("/data.json").then((res) => {
            console.log(res, "res");
            this.boxVideoImg = res.data[0].home.boxVideoImg;
            console.log(this.boxVideoImg, "ahsdhasdhas");
        });
    },
    mounted() {
        var wn = document.getElementById("ifrm").contentWindow;
        setTimeout(() => {
            wn.postMessage(
                {
                    deviceLegend: [
                        {
                            color: "#106a00",
                            name: "设备正常",
                        },
                        {
                            color: "#790500",
                            name: "设备故障",
                        },
                        {
                            color: "#777777",
                            name: "设备待机",
                        },
                        {
                            color: "#0060b9",
                            name: "已点检",
                        },
                        {
                            color: "#9e5d00",
                            name: "未点检",
                        },
                    ],
                    column: [
                        {
                            value: "test1",
                            name: "线体",
                        },
                        {
                            value: "test2",
                            name: "印刷机",
                        },
                        {
                            value: "test3",
                            name: "点胶机",
                        },
                        {
                            value: "test4",
                            name: "SPI",
                        },
                        {
                            value: "test5",
                            name: "涂覆机",
                        },
                        {
                            value: "test6",
                            name: "插件机",
                        },
                        {
                            value: "test7",
                            name: "固化炉",
                        },
                        {
                            value: "test8",
                            name: "贴片机",
                        },
                        {
                            value: "test9",
                            name: "回流焊",
                        },
                        {
                            value: "test10",
                            name: "刻玛机",
                        },
                        {
                            value: "test11",
                            name: "AOI",
                        },
                    ],
                    tableData: [
                        {
                            test1: { value: "SM01" },
                            test2: { value: "0,1" },
                            test3: { value: "1,2" },
                            test4: { value: "1,2" },
                            test5: { value: "1,2" },
                            test6: { value: "1,2" },
                            test7: { value: "1,2" },
                            test8: { value: "1,2" },
                            test9: { value: "1,2" },
                            test10: { value: "1,2" },
                            test11: { value: "1,2" },
                        },
                        {
                            test1: { value: "SM02" },
                            test2: { value: "0,1" },
                            test3: { value: "1,2" },
                            test4: { value: "1,2" },
                            test5: { value: "1,2" },
                            test6: { value: "1,2" },
                            test7: { value: "1,2" },
                            test8: { value: "1,2" },
                            test9: { value: "1,2" },
                            test10: { value: "1,2" },
                            test11: { value: "1,2" },
                        },
                        {
                            test1: { value: "SM03" },
                            test2: { value: "0,1" },
                            test3: { value: "1,2" },
                            test4: { value: "1,2" },
                            test5: { value: "1,2" },
                            test6: { value: "1,2" },
                            test7: { value: "1,2" },
                            test8: { value: "1,2" },
                            test9: { value: "1,2" },
                            test10: { value: "1,2" },
                            test11: { value: "1,2" },
                        },
                        {
                            test1: { value: "SM04" },
                            test2: { value: "0,1" },
                            test3: { value: "1,2" },
                            test4: { value: "1,2" },
                            test5: { value: "1,2" },
                            test6: { value: "1,2" },
                            test7: { value: "1,2" },
                            test8: { value: "1,2" },
                            test9: { value: "1,2" },
                            test10: { value: "1,2" },
                            test11: { value: "1,2" },
                        },
                        {
                            test1: { value: "SM05" },
                            test2: { value: "0,1" },
                            test3: { value: "1,2" },
                            test4: { value: "1,2" },
                            test5: { value: "1,2" },
                            test6: { value: "1,2" },
                            test7: { value: "1,2" },
                            test8: { value: "1,2" },
                            test9: { value: "1,2" },
                            test10: { value: "1,2" },
                            test11: { value: "1,2" },
                        },
                        {
                            test1: { value: "SM06" },
                            test2: { value: "0,1" },
                            test3: { value: "1,2" },
                            test4: { value: "1,2" },
                            test5: { value: "1,2" },
                            test6: { value: "1,2" },
                            test7: { value: "1,2" },
                            test8: { value: "1,2" },
                            test9: { value: "1,2" },
                            test10: { value: "1,2" },
                            test11: { value: "1,2" },
                        },
                        {
                            test1: { value: "SM07" },
                            test2: { value: "0,1" },
                            test3: { value: "1,2" },
                            test4: { value: "1,2" },
                            test5: { value: "1,2" },
                            test6: { value: "1,2" },
                            test7: { value: "1,2" },
                            test8: { value: "1,2" },
                            test9: { value: "1,2" },
                            test10: { value: "1,2" },
                            test11: { value: "1,2" },
                        },
                        {
                            test1: { value: "SM08" },
                            test2: { value: "0,1" },
                            test3: { value: "1,2" },
                            test4: { value: "1,2" },
                            test5: { value: "1,2" },
                            test6: { value: "1,2" },
                            test7: { value: "1,2" },
                            test8: { value: "1,2" },
                            test9: { value: "1,2" },
                            test10: { value: "1,2" },
                            test11: { value: "1,2" },
                        },
                        {
                            test1: { value: "SM09" },
                            test2: { value: "0,1" },
                            test3: { value: "1,2" },
                            test4: { value: "1,2" },
                            test5: { value: "1,2" },
                            test6: { value: "1,2" },
                            test7: { value: "1,2" },
                            test8: { value: "1,2" },
                            test9: { value: "1,2" },
                            test10: { value: "1,2" },
                            test11: { value: "1,2" },
                        },
                        {
                            test1: { value: "SM10" },
                            test2: { value: "0,1" },
                            test3: { value: "1,2" },
                            test4: { value: "1,2" },
                            test5: { value: "1,2" },
                            test6: { value: "1,2" },
                            test7: { value: "1,2" },
                            test8: { value: "1,2" },
                            test9: { value: "1,2" },
                            test10: { value: "1,2" },
                            test11: { value: "1,2" },
                        },
                    ],
                    echartData: {
                        dataX: [
                            {
                                value: 1048,
                                name: "设备正常",
                                itemStyle: { color: "#106a00" },
                            },
                            {
                                value: 735,
                                name: "设备故障",
                                itemStyle: { color: "#790500" },
                            },
                            {
                                value: 735,
                                name: "设备待机",
                                itemStyle: { color: "#777777" },
                            },
                        ],
                        dataY: [
                            {
                                value: 1048,
                                name: "已点检",
                                itemStyle: { color: "#106a00" },
                            },
                            {
                                value: 735,
                                name: "未点检",
                                itemStyle: { color: "#790500" },
                            },
                        ],
                    },
                },
                "http://192.168.30.178:8084"
            );
        }, 3000);
    },
};
</script>

<style scoped>
.ceshi {
    overflow: hidden;
    margin: auto;
    height: 100%;
    width: 100%;
}
</style>
